import { render, staticRenderFns } from "./DocuTours.vue?vue&type=template&id=0c0504ba&scoped=true&"
import script from "./DocuTours.vue?vue&type=script&lang=js&"
export * from "./DocuTours.vue?vue&type=script&lang=js&"
import style0 from "./DocuTours.vue?vue&type=style&index=0&id=0c0504ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0504ba",
  null
  
)

export default component.exports